<script>
    import { Pie } from 'vue-chartjs'
    import createChart from './mixins/createChart'

    export default {
        extends: Pie,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
                default: () => {}
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data() {
            return {
                targetDataset: this.chartData.datasets.filter(dataset => dataset.target),

                dataStyling: {
                    backgroundColor: [
                        '#18BDCB', // blue
                        '#7DD0A9', // green
                        '#FFE97E', // yellow
                        '#FFB375', // orange
                        '#FF5D67', // red
                        '#B72424', // deep red
                        '#D42488', // purple
                        '#FFB1DD', // pink
                        '#C2A9B7', // mauve
                        '#757CE9', // voilet
                    ],
                    borderWidth: 0
                },

                htmlLegend: null,

                options: {
                    cutoutPercentage: 50,

                    legend: {
                        display: false
                    },

                    legendCallback: chart => {
                        let text = []

                        let metricTotal = 0

                        for (let i = 0; i < chart.data.labels.length; i++) {
                            metricTotal += chart.data.datasets[0].data[i]
                        }

                        text.push(`<ul class="${chart.id}-legend max-w-full md:max-w-174 mt-16 md:mt-0">`)

                        for (let i = 0; i < chart.data.labels.length; i++) {
                            //let dataFormatted = chart.data.datasets[0].data[i].toLocaleString()

                            let dataAsPercent = (chart.data.datasets[0].data[i]/metricTotal)*100

                            text.push('<li class="flex flex-wrap text-14 mb-4 cursor-pointer">')

                            text.push(`<span class="block w-14 h-14" style="background-color:${chart.data.datasets[0].backgroundColor[i]}"></span>`)
                            text.push(`<span class="break-all leading-tight pl-8">${chart.data.labels[i]}, ${dataAsPercent.toFixed(2)}%</span>`)

                            if (this.hasTargets) {
                                let target = this.targetDataset.find(dataset => dataset.label === chart.data.labels[i])
                                if (target) {
                                    if (target.data[0]) {
                                        let targetFormatted = Math.round(target.data[0]).toLocaleString()

                                        if (!chart.data.isInverted) {
                                            if ( target.data[0] <= chart.data.datasets[0].data[i] ) {
                                                text.push(`<span class="w-full leading-tight pl-22 pt-4 text-green"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(-33.25 12.879) rotate(-90)" fill="#53ff4d"/></svg> Target, ${targetFormatted}</span>`)
                                            } else {
                                                text.push(`<span class="w-full leading-tight pl-22 pt-4 text-coral"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(43.25) rotate(90)" fill="#ff5d67"/></svg> Target, ${targetFormatted}</span>`)
                                            }
                                        }

                                        if (chart.data.isInverted) {
                                            if ( target.data[0] <= chart.data.datasets[0].data[i] ) {
                                                text.push(`<span class="w-full leading-tight pl-22 pt-4 text-coral"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(-33.25 12.879) rotate(-90)" fill="#ff5d67"/></svg> Target, ${targetFormatted}</span>`)
                                            } else {
                                                text.push(`<span class="w-full leading-tight pl-22 pt-4 text-green"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(43.25) rotate(90)" fill="#53ff4d"/></svg> Target, ${targetFormatted}</span>`)
                                            }
                                        }
                                    }
                                }
                            }

                            text.push('</li>')
                        }

                        text.push('</ul>')

                        return text.join('')
                    },

                },
            }
        },

        mounted () {
            this.buildSingleDimensionChartData()
            this.createChart()
            this.createCustomLegend('right')

            this.$on('chart:destroy', () => {
                this.buildSingleDimensionChartData()
            })

            this.$on('chart:render', () => {
                this.createCustomLegend('bottom')
            })
        }

    }
</script>